import { useTheme } from 'styled-components';
import { useMediaQuery } from 'react-responsive';

export const useIsMobile = () => {
    const theme = useTheme();
    return useMediaQuery({
        query: theme?.sizes.mediaQueries.mobileMax,
    });
};
